module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.e9a9d28.woff2";